import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CFETILMSheerIdApiConstant } from 'src/app/cfet-core/constants/cfet-ilm-sheerid-api.constant';
import { SheeridApiService } from 'src/app/cfet-core/core-services/sheeridapiservice.service';
import { SheerIdApiIntegrationPayload } from 'src/app/interface-models/sheer-id-api-interface';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-skip-for-now-modal-utf',
    templateUrl: './skip-for-now-modal-utf.component.html',
    styleUrls: ['./skip-for-now-modal-utf.component.scss'],
    standalone: false
})
export class SkipForNowModalUtfComponent extends CfetBaseComponent {

  constructor(private readonly sheeridApiService: SheeridApiService) { super(); }
  @Input() openModal: string;
  @Input() selectedFile: string;
  @Output() modalCloseEvent = new EventEmitter<any>();


  async skipForNow(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const sheerIdApiIntegrationData = sessionStorage.getItem('sheerIdApiIntegrationData') ? JSON.parse(sessionStorage.getItem('sheerIdApiIntegrationData')) : null;
      if (sheerIdApiIntegrationData) {
        await this.postSheerIdApiIntegrationData(sheerIdApiIntegrationData);
      }
      sessionStorage.setItem('skipDocUpload',"true");
      const url = environment.getBrowserPath() + CfetPageNamesConstant.CUSTOMER_PROFILE_UTF;
      this.redirectUrl(url);
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click'
      || event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }
  
   async postSheerIdApiIntegrationData(sheerIdApiIntegrationData: any) {
        const sheerIdApiPayload: SheerIdApiIntegrationPayload = {
        isActive: 'TRUE',
        company_user_id: sheerIdApiIntegrationData?.company_user_id,
        company_id: 21,
        userid: sheerIdApiIntegrationData?.userid,
        verification: {
          process: CFETILMSheerIdApiConstant.processName,
          phase: {
            name: CFETILMSheerIdApiConstant.ILMDocUpload,
          },
          step: CFETILMSheerIdApiConstant.submitDocuments,
        },
        sheerId: {
          programId: sheerIdApiIntegrationData?.sheerId?.programId,
          verificationId: sheerIdApiIntegrationData?.sheerId?.verificationId,
          status: CFETILMSheerIdApiConstant.SheerIdDocUpload,
        },
        trigger: {
          source: CFETILMSheerIdApiConstant.source,
        },
      };
      await this.sheeridApiService
        .sendSheerIdApiIntegrationData(sheerIdApiPayload)
        .toPromise()
        .then((response: any) => {
          console.log("SheerId API SkipForNowModalUtfComponent integration response----->:", response);
        })
        .catch((error: any) => {
          console.error("SheerId API SkipForNowModalUtfComponent integration error------>:", error);
        });
      }

}
